/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Defines possible options for workload management. READ_ONLY - workload watched (metrics collected), but no actions may be performed by CAST AI. MANAGED - workload watched (metrics collected), CAST AI may perform actions on the workload.
 * @export
 * @enum {string}
 */

export const WorkloadoptimizationV1ManagementOption = {
    UNDEFINED: 'UNDEFINED',
    READ_ONLY: 'READ_ONLY',
    MANAGED: 'MANAGED'
} as const;

export type WorkloadoptimizationV1ManagementOption = typeof WorkloadoptimizationV1ManagementOption[keyof typeof WorkloadoptimizationV1ManagementOption];



